import React, {useState}      from 'react';
import classnames             from 'classnames';
import Tooltip                from './Tooltip';
import Label                  from './Label';

const FileLabel = (props) => {
  if (props.label === null || props.label === '') {
    return null;
  }
  return (
    <Label
      label={props.label}
      required={props.required}> <Tooltip id={`tooltip-${props.name}`} title={props.tooltip} />
    </Label>
  );

}

const FileComponent = (props) => {
  const [fileName, setFileName] = useState(props.fileName);

  const inputClassName = classnames({
    'ignore-validate': !props.isFileRequired,
  }, props.inputClassName);

  const uploadFile = (event) => {
    const file = event.target.files[0];
    const fileName = file ? file.name : '';
    setFileName(fileName);
    props.onChangeParameter(props.name, fileName);
    if(props.processFile) props.processFile(file);
  }

  return (
    <div className="file-input d-grid">
      <FileLabel {...props} />
      <div className={props.btnClassName}>
        {props.text}
        <input
          id={props.inputId}
          type="file"
          className={inputClassName}
          name={`${props.groupName}[${props.name}]`}
          onChange={uploadFile} />
      </div>
      <div>{fileName}</div>
    </div>
  )
}

FileComponent.defaultProps = {
  name     : 'filename',
  groupName: 'parameters',
  label    : 'FileComponent',
  text     : 'Upload File',
  fileName : '',
  inputId  : null,
  btnClassName: 'btn btn-secondary-clear btn-filename',
};

export default FileComponent;